// Per-mode SVG cleanup for the BPM headless export — ports of the three legacy
// formatSVG implementations (bpm/mds/chart.coffee, bpm/tv/chart.coffee,
// bpm/quadrant/chart.coffee). All three clone the LIVE <svg> (never chart.getSVG():
// quadrant's axis centering + collision labels and mds/tv custom layers are direct
// DOM mutations that a Highcharts re-render would lose).

const SVG_NS = 'http://www.w3.org/2000/svg'

const insertWhiteBackground = (svg, width, height) => {
  const rect = document.createElementNS(SVG_NS, 'rect')
  rect.setAttribute('x', '0')
  rect.setAttribute('y', '0')
  rect.setAttribute('width', String(width))
  rect.setAttribute('height', String(height))
  rect.setAttribute('fill', '#ffffff')
  svg.insertBefore(rect, svg.firstChild)
}

const setStyles = (el, styles) => {
  for (const [prop, value] of Object.entries(styles)) el.style[prop] = value
}

export function buildBpmSvgForExport(svgNode, mode) {
  if (!svgNode) throw new Error('bpm: chart SVG not found')

  const width = svgNode.width.baseVal.value
  const height = svgNode.height.baseVal.value
  const svg = svgNode.cloneNode(true)

  if (mode === 'm') {
    svg.querySelectorAll('g.download').forEach(el => el.remove())
    insertWhiteBackground(svg, width, height)
  } else if (mode === 't') {
    // The cloned svg loses page CSS — inline the pin/flag/legend fonts (legacy parity;
    // the React svg also embeds them in <defs><style>, inlining is belt-and-braces).
    svg.querySelectorAll('text.pin-label-text, text.flag-label').forEach(el => {
      setStyles(el, { fontFamily: 'Ubuntu, Arial', fontSize: '11px', lineHeight: '13px' })
    })
    svg
      .querySelectorAll(
        'text.pmap-topography-legend-title, text.pmap-topography-legend-max, text.pmap-topography-legend-min'
      )
      .forEach(el => {
        setStyles(el, { fontFamily: 'Ubuntu, Arial', fontSize: '13px', lineHeight: '15px' })
      })

    svg
      .querySelectorAll(
        "[id^='pmaptopo-download-on-'], [id^='pmaptopo-download-click-'], .pin-label.pin-label-hidden, g.download, text.pmap-topography-legend-title a"
      )
      .forEach(el => el.remove())
  } else if (mode === 'q') {
    // linearGradient removal is legacy parity — HC bubble gradients broke svgToCanvas.
    svg.querySelectorAll('linearGradient').forEach(el => el.remove())
    svg.querySelectorAll('.highcharts-button:not(.highcharts-breadcrumbs-button)').forEach(el => el.remove())
    insertWhiteBackground(svg, width, height)
  }

  return '<?xml version="1.0" encoding="UTF-8" standalone="no"?>' + new XMLSerializer().serializeToString(svg)
}
